import { useQuery } from '@tanstack/react-query';

import {
  pointsTransactionsService,
  FetchPointsTransactionsRequest,
  FetchPointsTransactionsResponse,
} from '@aslanpay/portal-common-lib';

const useFetchPointsTransactions = ({
  ids,
  individualIds,
  potIds,
  walletIds,
  companyIds,
  moneyTransactionIds,
  directions,
  categories,
  reasons,
  startDate,
  endDate,
  sortBy,
  sort,
  page,
  size,
}: FetchPointsTransactionsRequest) => {
  return useQuery<FetchPointsTransactionsResponse, Error>(
    [
      'fetchPointsTransactions',
      ids,
      individualIds,
      potIds,
      walletIds,
      companyIds,
      moneyTransactionIds,
      directions,
      categories,
      reasons,
      startDate,
      endDate,
      sortBy,
      sort,
      page,
      size,
    ],
    () =>
      pointsTransactionsService.fetchPointsTransactions({
        ids,
        individualIds,
        potIds,
        walletIds,
        companyIds,
        moneyTransactionIds,
        directions,
        categories,
        reasons,
        startDate,
        endDate,
        sortBy,
        sort,
        page,
        size,
      })
  );
};

export default useFetchPointsTransactions;
